import axios from "axios";

export class ErrorsClient {
    baseUrl;

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    getErrors(columnFiltersQuery, sortQuery, pageNumber, pageSize, ended) {
        return axios.get(`${this.baseUrl}/errors`,
            {
                params: {
                    searchQuery: ended ? columnFiltersQuery : `ended==${ended}${columnFiltersQuery ? `;${columnFiltersQuery}` : ''}` ,
                    sortQuery: sortQuery,
                    page: pageNumber,
                    size: pageSize,
                }
            });
    }

    updateError(obj) {
        return axios.put(`${this.baseUrl}/errors`, obj)
    }
}
